// extracted by mini-css-extract-plugin
export default {"root":"IconSuccess_root__s21G+","fillColor":"IconSuccess_fillColor__xuUgg"};